// removed by extract-text-webpack-plugin
module.exports = {"container":"DashboardNoResults-container","content":"DashboardNoResults-content","iconContainer":"DashboardNoResults-iconContainer"};